var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46065 4.5325L15.2173 9.64083C15.2801 9.67757 15.3321 9.73009 15.3683 9.79317C15.4045 9.85625 15.4235 9.9277 15.4235 10.0004C15.4235 10.0731 15.4045 10.1446 15.3683 10.2077C15.3321 10.2707 15.2801 10.3233 15.2173 10.36L6.46065 15.4683C6.39721 15.5054 6.32511 15.525 6.25165 15.5251C6.1782 15.5253 6.106 15.5061 6.04238 15.4693C5.97876 15.4326 5.92597 15.3797 5.88938 15.316C5.85278 15.2524 5.83367 15.1801 5.83399 15.1067V4.8925C5.83397 4.81919 5.85329 4.74717 5.89001 4.68371C5.92672 4.62025 5.97953 4.5676 6.0431 4.53108C6.10667 4.49456 6.17876 4.47547 6.25207 4.47571C6.32538 4.47596 6.39733 4.49555 6.46065 4.5325Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.81eaac15.svg";
export { ForwardRef as ReactComponent };